import styled from '@emotion/styled';
import { pxToRem, Text, withEllipsis } from '@lbcamden/lib-react';

export const ExtraInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const UserName = styled(Text)`
  ${withEllipsis}
  max-width: fit-content;
  cursor: default;
`;

export const UserEmail = styled.a`
  ${({ theme }) => theme.text.body2};
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.primary};

  svg {
    flex-shrink: 0;
    height: ${pxToRem(16)};
  }
`;
